import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { globalVar } from '../../shared/global_variables';
import { HttpClient } from '@angular/common/http';
import { TextValue } from '../../analysis/models/criterions/TextValue';

export const HELP = '/help';
export const GET_HELP_PAGE_LINK = '/getHelpPageLinkByKey';
@Injectable({
    providedIn: 'root'
})
export class HelpService {
    constructor(private httpClient: HttpClient) {}

    public getExternalHelpLink(key: string): Observable<TextValue> {
        return this.httpClient.get<TextValue>(environment.baseUrl + globalVar.requestPrefix + HELP + GET_HELP_PAGE_LINK + '/' + key, {});
    }
}
